import styled from "styled-components";

export const InputStyled = styled.div`
  label {
    margin-bottom: 10px;
    display: inline-block;
    font-weight: 400;
    font-size: 15px;
    text-align: center;
    color: rgb(255, 255, 255);
  }

  .cmn_input_Wrap {
    width: 100%;
    min-height: 48px;
    background: rgba(217, 217, 217, 0.2);
    border: 1px solid rgb(255, 255, 255);
    backdrop-filter: blur(6.4px);
    border-radius: 25px;
    padding: 12.4px 29px 9.4px;
    @media (max-width: 1199px) {
      border-radius: 15px;
    }
    @media (max-width: 899px) {
      border-radius: 12px;
    }
    input {
      width: 100%;
      border: none;
      background: transparent;
      font-weight: 400;
      font-size: 15px;
      color: rgb(255, 255, 255);
      /* &:-webkit-autofill,
      &:-webkit-autofill:hover,
      &:-webkit-autofill:focus,
      &:-webkit-autofill:active {
         background-color: transparent !important;
      } */

      &::placeholder {
        font-weight: 400;
        font-size: 15px;
        color: rgb(255, 255, 255);
      }
      &:focus-visible {
        border: none;
        outline: none;
        background: transparent;
      }
    }
    /* input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus {
      background-color: transparent;
      -webkit-box-shadow: 0 0 0px 1000px rgb(22 22 22 / 86%) inset;
      -webkit-text-fill-color: rgb(255, 255, 255);
      transition: background-color 0s ease-in-out 0s;
    } */
    /* input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
      -webkit-box-shadow: 0 0 0 1000px rgb(22 22 22 / 86%) inset !important;
      background-color: transparent !important;
      -webkit-text-fill-color: #ffffff !important; 
      caret-color: #ffffff !important;
      color: #ffffff !important;
      transition: background-color 0s ease-in-out 0s;
    } */

    textarea {
      width: 100%;
      border: none;
      background: transparent;
      resize: none;
      font-weight: 400;
      font-size: 15px;
      color: rgb(255, 255, 255);
      &::-webkit-scrollbar {
        width: 5px;
      }
      &::-webkit-scrollbar-track {
        background: rgb(241, 241, 241);
        border-radius: 20px;
      }
      &::-webkit-scrollbar-thumb {
        background: rgba(255, 24, 24, 0.5);
        border-radius: 20px;
      }
      &::-webkit-scrollbar-thumb:hover {
        background: rgb(85, 85, 85);
      }
      &::placeholder {
        font-weight: 400;
        font-size: 15px;
        color: rgb(255, 255, 255);
      }
      &:focus-visible {
        border: none;
        outline: none;
        background: transparent;
      }
    }
  }
`;
